// Angular dependencies.
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Effect, Actions } from '@ngrx/effects';
import { Action } from '@ngrx/store';

// Rxjs dependencies
import 'rxjs/add/operator/let';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/withLatestFrom';
// import 'rxjs/add/operator/let';
import 'rxjs/add/operator/ignoreElements';
import { Observable } from 'rxjs/Observable';
import { mergeMap } from 'rxjs/operators';
import { forkJoin } from 'rxjs/observable/forkJoin';

// Store
import { Store } from '@ngrx/store';
import { AppState, selectCreepActions } from './app.reducer';
import { CREEP_UNDO_ACTION } from './creep.actions';

// App dependencies.
import { Skill } from '../creep-skill';

@Injectable()
export class CreepEffects {
  @Effect({ dispatch: false })
  historyUndo$: Observable<[Action, Skill[]]> = this.actions$
    .ofType(CREEP_UNDO_ACTION)
    .withLatestFrom(this._store.select(selectCreepActions))
    .do(([payload, skills]) => {
      const skill = skills.pop();
      skill.decLevel();
    });

  constructor(
    private actions$: Actions,
    private _store: Store<AppState>,
    private _route: ActivatedRoute,
    private _router: Router
  ) { }
}



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/store.module/creep.effects.ts